import React from 'react'

export const Form: React.FC<React.HTMLProps<HTMLFormElement>> = ({ children, ...props }) => (
  <form {...props}>{children}</form>
)
